import { render, staticRenderFns } from "./discountSelection.vue?vue&type=template&id=59ddc916&scoped=true"
import script from "./discountSelection.vue?vue&type=script&lang=js"
export * from "./discountSelection.vue?vue&type=script&lang=js"
import style0 from "./discountSelection.vue?vue&type=style&index=0&id=59ddc916&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ddc916",
  null
  
)

export default component.exports